import React from "react";
import { CouponForUser } from "components/courses/queries";
import { formatUSD } from "helpers/strings";
import styles from "./CouponDiscount.module.css";

interface Props {
  couponForUser: CouponForUser;
}

const CouponDiscount = ({ couponForUser }: Props) => {
  return (
    <div className={styles.priceWithCouponWrapper}>
      <div className={styles.priceWithCouponValue}>
        {formatUSD(couponForUser.discountedPriceUSD)}
      </div>
      when you use code
      <div className={styles.priceWithCouponCode}>{couponForUser.code}</div>
    </div>
  );
};

export default CouponDiscount;
